import { apiPost } from "../shared/apiClient";
import { createCachedFetcher } from "../shared/cachedFetcher";

const fetchSupplierGroupsRaw = createCachedFetcher(
  () => apiPost("/whatsapp/get_supplier_tags", {}).then(res =>
    res.data?.success ? (res.data.data || []).map(g => ({ value: g.id, label: g.name })) : []
  ),
  { fallback: [] }
);

export function fetchSupplierGroups({ force = false } = {}) {
  return fetchSupplierGroupsRaw(undefined, { force });
}

const fetchSuppliersV2Raw = createCachedFetcher(
  () => apiPost("/whatsapp/get_suppliersV2", {}).then(res =>
    res.data?.success ? (res.data.data || []) : []
  ),
  { fallback: [] }
);

export function fetchSuppliersV2({ force = false } = {}) {
  return fetchSuppliersV2Raw(undefined, { force });
}

export function fetchSuppliersByGroups(groupIds) {
  return apiPost("/whatsapp/get_suppliers", { make: groupIds })
    .then(res => {
      const raw = Array.isArray(res.data) ? res.data : (res.data?.data || []);
      return [...raw].sort((a, b) => (b.supplier_score ?? 0) - (a.supplier_score ?? 0));
    })
    .catch(() => []);
}

export function previewSupplierMessage({ taskId, isInternational, selection }) {
  return apiPost("/query_workflow/send_to_suppliers_v2/preview", {
    task_id: taskId, is_international: isInternational, selection,
  })
    .then(res => (res.data?.success && res.data.data?.message != null) ? res.data.data.message : null)
    .catch(() => null);
}

export function sendToSuppliers({ taskId, userId, isInternational, sendAcknowledgement, selectedGroups, suppliers, selection }) {
  return apiPost("/query_workflow/send_to_suppliers_v2", {
    task_id: taskId,
    userId,
    is_international: isInternational,
    send_acknowledgement: sendAcknowledgement,
    selected_groups: selectedGroups,
    suppliers,
    selection,
  }).then(res => res.data);
}
